exports.ByStatusName = {
  incomplete: 0,
  complete: 1
};
